import { useTimeFormatter } from '../hooks/use-time-formatter';

interface TimeDisplayProps {
  currentTime: number;
  duration: number;
}

export const TimeDisplay: React.FC<TimeDisplayProps> = ({ currentTime, duration }) => {
  const { formatTime } = useTimeFormatter();

  return (
    <div className="flex justify-between items-center mb-4">
      <div className="text-background text-sm">{formatTime(currentTime)}</div>
      <div className="text-background text-sm">{formatTime(duration)}</div>
    </div>
  );
};
